(function () {
  'use strict';
  /* LANGUES ROUTEES, SEUL ENDROIT A MODIFIER (03/10/2026).
     Le relais Render /api/newsletter (depot casemira-visualiseur, lib/newsletter.js)
     choisit la liste Klaviyo par langue, cote serveur : le navigateur n'envoie jamais
     d'identifiant de liste. fr SiJZYk, de SNNWta, nl RRwCpn, en SB8RVU ; it W2cqkh et
     es XNChQL (listes creees le 03/10/2026).
     03/10/2026 (soir) : 'it' et 'es' ajoutes, meme chemin que nl et en (langue de la
     page, source popup ou footer). Le relais les accepte en production depuis le
     03/10/2026 19h25 (version 68431e5). Une langue absente du relais y recevrait un
     400 `invalid_context` et le formulaire afficherait le message d'echec : n'ajouter
     ici une langue qu'une fois le relais deploye pour elle. La pop-up lit la meme
     liste par `window.cmNewsletterRelais`.
     POPUP_RELAIS : le francais garde l'ancien chemin Klaviyo de la pop-up (liste
     SiJZYk, source « Pop-up Newsletter -10% »), choix anterieur conserve.
     04/10/2026 : 'pt', 'cs', 'sk', 'da' ajoutes (listes pt S547La, cs VzgCrJ, sk SwNDFZ,
     da WE4cYc, cote relais). La langue envoyee est la forme courte (« pt » pour la
     locale pt-PT), celle que `normalizeLocale` du relais attend. ATTENTION : le relais
     ne les accepte que sur la branche `i18n-vague-a` du depot casemira-visualiseur
     (commits 01ce7cb, daf40d9), NON DEPLOYEE au 04/10. Ces quatre langues ne sont pas
     publiees, donc aucun visiteur ne passe ici ; mais le relais doit etre deploye
     AVANT la publication de l'une d'elles, sinon son inscription echoue (400).
     04/10/2026 (11h) : 'hu' (liste RPakHY), relais sur la branche `i18n-vague-b` (b9cb74f),
     NON DEPLOYEE : meme reserve.
     04/10/2026 (15h) : 'hr' (liste Newsletter HR TsjHxF) et 'ro' (Newsletter RO TwWXT5), meme
     branche `i18n-vague-b` (LIST_IDS de lib/newsletter.js), NON DEPLOYEE : meme reserve. Les
     listes visualiseur HR VM9pjp et RO UGmNLV sont choisies par le visualiseur, pas ici.
     04/10/2026 (22h) : 'sv' (Newsletter SV UixJxb), 'fi' (XgnsVw), 'el' (Vpjj5D) ; relais sur la
     branche `i18n-vague-c` du depot casemira-visualiseur (commits 43c5ae8, d60e7cd, LIST_IDS de
     lib/newsletter.js), NON DEPLOYEE (main porte hu, ro, hr) : meme reserve, deployer avant de
     publier l'une de ces langues. Listes visualiseur SV W6XC3E, FI SruAFi, EL SXSnWx : choisies
     par le visualiseur, pas ici.
     06/10/2026 (vague D) : 'bg' (Newsletter BG Um9tBD), 'sl' (RiFuRU), 'lv' (VrV4a7) ; relais sur la
     branche `i18n-vague-d` du depot casemira-visualiseur (commits b36cf04, c1378d0, 344bfc0, LIST_IDS
     de lib/newsletter.js), NON DEPLOYEE au 06/10 03h (origin/main porte jusqu'a sv) : deployer avant
     de publier l'une de ces langues. Listes visualiseur BG RVGxux, SL Su6jKL, LV UNTZxu : cote
     visualiseur. 'et' (Newsletter ET Spt5qn, visualiseur X9HFjc) ajoute le 06/10 : meme branche
     `i18n-vague-d` (commit 247438b), NON DEPLOYEE : meme reserve. 'lt' (Newsletter LT XRmYhd, visualiseur
     RR5h99) ajoute le 06/10 vers 04h50 : meme branche `i18n-vague-d` (commit f48d8dc), NON DEPLOYEE. */
  var RELAIS = ['fr', 'de', 'en', 'nl', 'it', 'es', 'pt', 'cs', 'sk', 'da', 'hu', 'hr', 'ro', 'sv', 'fi', 'el', 'bg', 'sl', 'lv', 'et', 'lt'];
  var POPUP_RELAIS = RELAIS.filter(function (l) { return l !== 'fr'; });
  window.cmNewsletterRelais = { formulaires: RELAIS, popup: POPUP_RELAIS };
  var locale = document.documentElement.lang.toLowerCase().split('-')[0];
  if (RELAIS.indexOf(locale) === -1 || window.cmNewsletterRoutingReady) return;
  window.cmNewsletterRoutingReady = true;
  var busy = new WeakSet();
  // Popup DE, NL, EN, IT, ES, PT, CS, SK, DA, HU, HR, RO, SV, FI, EL, BG, SL, LV, ET, LT et formulaires newsletter : même liste et même écran de code par langue.
  document.addEventListener('submit', async function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    var popup = form.id === 'CasemiraPopupForm';
    if (popup ? POPUP_RELAIS.indexOf(locale) === -1 : form.getAttribute('is') !== 'newsletter-form') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (busy.has(form) || !form.reportValidity()) return;
    var email = form.querySelector('input[name="contact[email]"]');
    if (!email) return;
    busy.add(form);
    var buttons = Array.from(form.querySelectorAll('[type="submit"]'));
    buttons.forEach(function (button) { button.disabled = true; });
    var status = form.querySelector('[data-cm-newsletter-status]');
    if (!status) {
      status = document.createElement('p');
      status.setAttribute('data-cm-newsletter-status', '');
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      form.appendChild(status);
    }
    status.textContent = '';
    var controller = new AbortController();
    var timeout = setTimeout(function () { controller.abort(); }, 20000);
    var params = new URLSearchParams(location.search);
    var script = document.querySelector('script[data-cm-newsletter-routing]');
    var payload = {
      email: email.value.trim(), locale: locale, market: script ? script.dataset.market : '',
      source: popup ? 'popup' : 'footer', page: location.pathname, marketingConsent: true,
      acquisition_source: params.get('utm_source') || 'direct',
      acquisition_medium: params.get('utm_medium') || '', acquisition_campaign: params.get('utm_campaign') || ''
    };
    try {
      var response = await fetch('https://casemira-visualiseur.onrender.com/api/newsletter', {
        method: 'POST', signal: controller.signal,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      if (response.status !== 202) throw new Error('Subscription rejected');
      try { localStorage.setItem('casemira_popup_subscribed', '1'); } catch (_) {}
      try { sessionStorage.setItem('cmp_pending', '1'); } catch (_) {}
      try { document.cookie = 'cmp_pending=1; path=/; max-age=600; SameSite=Lax'; } catch (_) {}
      // Le code existant de la popup apparaît seulement après le retour réussi de Shopify.
      HTMLFormElement.prototype.submit.call(form);
    } catch (_) {
      /* Message d'echec : la cle `casemira.newsletter.erreur_inscription` de la langue
         courante, posee sur la balise script par snippets/newsletter-form.liquid. La
         table ci-dessous n'est que le repli d'une page servie sans l'attribut. */
      status.textContent = (script && script.dataset.erreur) || {
        fr: "L'inscription a échoué. Veuillez réessayer.",
        de: 'Die Anmeldung hat leider nicht geklappt. Bitte versuchen Sie es erneut.',
        en: 'Your subscription could not be completed. Please try again.',
        nl: 'Aanmelden is niet gelukt. Probeer het opnieuw.',
        it: 'Iscrizione non riuscita. Riprova tra qualche istante.',
        es: 'No se ha podido completar la suscripción. Inténtalo de nuevo.',
        pt: 'Não foi possível concluir a subscrição. Tente novamente.',
        cs: 'Přihlášení se nezdařilo. Zkuste to prosím znovu.',
        sk: 'Prihlásenie sa nepodarilo. Skúste to znova.',
        da: 'Tilmeldingen mislykkedes desværre. Prøv igen.',
        hu: 'Nem sikerült a feliratkozás. Próbáld újra.',
        hr: 'Prijava nije uspjela. Pokušajte ponovno.',
        ro: 'Înscrierea nu a reușit. Încearcă din nou.',
        sv: 'Anmälan misslyckades. Försök igen.',
        fi: 'Uutiskirjeen tilaus epäonnistui. Yritä uudelleen.',
        el: 'Η εγγραφή απέτυχε. Δοκίμασε ξανά.'
      }[locale] || '';
      busy.delete(form);
      buttons.forEach(function (button) { button.disabled = false; });
    } finally {
      clearTimeout(timeout);
    }
  }, true);
})();
